import axios from "axios";
import { IAxiosResponse } from "../interfaces/IAxiosResponse";
import {
  IAvailableEndpoint,
  IMcpTool,
  IMcpToolUpdate
} from "../interfaces/endpoints/IMcpTool";

export const getAllMcpTools = async (): Promise<IAxiosResponse<IMcpTool[]>> => {
  return axios.get("v1/Mcp/Tools/All");
};

export const updateMcpTool = async (
  id: number,
  body: IMcpToolUpdate
): Promise<IAxiosResponse<IMcpTool>> => {
  return axios.put(`v1/Mcp/Tools/${id}`, body);
};

export const createMcpTool = async (
  body: IMcpToolUpdate
): Promise<IAxiosResponse<IMcpTool>> => {
  return axios.post("v1/Mcp/Tools", body);
};

export const getAvailableEndpoints = async (): Promise<
  IAxiosResponse<IAvailableEndpoint[]>
> => {
  return axios.get("v1/Mcp/Tools/Available");
};

export const importToolsFromApi = async (): Promise<
  IAxiosResponse<{ imported: number }>
> => {
  return axios.post("v1/Mcp/Tools/Import");
};
